// Google tag (gtag.js) for the sign-up conversion only.
//
// The Google tag is deliberately NOT loaded app-wide: the authenticated app's URLs can carry
// reset/SSO tokens and customer data, and we don't want those sent to Google. It is loaded lazily
// from the public registration page (see Register.js), which is the only place that needs it.
//
// Attribution: the marketing site (cataam.com) sets the Google Ads / GA cookies on the root domain
// (.cataam.com), so this tag on app.cataam.com reads the same click id and client id. No linker
// parameters are needed because both sites share the registered domain.
//
// Everything here no-ops outside a browser and never throws, so analytics can't break sign-up.
const GA4_ID = 'G-NX6D8GSVB3';          // cataam-website-v2 (same property as cataam.com)
const ADS_ID = 'AW-18540954528';        // Google Ads account 770-311-4005
export const ADS_SIGNUP_SEND_TO = `${ADS_ID}/NT-oCMas_asdEKCHgolF`; // "Sign-up" conversion action

let loaded = false;

export function loadGoogleTag() {
  if (loaded || typeof window === 'undefined' || typeof document === 'undefined') return;
  loaded = true;
  try {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function gtag() { window.dataLayer.push(arguments); };
    }
    window.gtag('js', new Date());
    // send_page_view:false — never report this app's hash URLs as pageviews.
    window.gtag('config', GA4_ID, { send_page_view: false });
    window.gtag('config', ADS_ID, { send_page_view: false });
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
  } catch {
    /* swallow — analytics must never affect the page */
  }
}

// Call only after the API has confirmed the registration succeeded.
export function trackSignupConversion() {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', 'sign_up', { method: 'email' });
    window.gtag('event', 'conversion', { send_to: ADS_SIGNUP_SEND_TO });
  } catch {
    /* swallow */
  }
}
